/**
 * **Kennungen und Zeitstempel** im Notizbuch.
 *
 * Beide stehen in Dateinamen auf dem Dateiserver. Sie müssen sich deshalb **nach Zeit sortieren
 * lassen, ohne die Datei zu öffnen** – „die jüngste Fassung" ist die mit dem größten Namen – und
 * dürfen sonst nichts verraten. Keine Titel, keine Personen.
 */

const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

function zufall(zeichen: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(zeichen))
  return [...bytes].map((b) => CROCKFORD[b % 32]).join('')
}

/**
 * Eine ULID: 10 Zeichen Zeit (Millisekunden, Crockford-Base32) + 16 Zeichen Zufall. 26 Zeichen,
 * alphabetisch = zeitlich sortiert. Dieselbe Form, die Work für Aufgaben benutzt.
 */
export function neueKennung(jetzt: number = Date.now()): string {
  let zeit = ''
  let rest = jetzt
  for (let i = 0; i < 10; i++) {
    zeit = CROCKFORD[rest % 32] + zeit
    rest = Math.floor(rest / 32)
  }
  return zeit + zufall(16)
}

/**
 * Ein Zeitstempel für Dateinamen: `20261020T103612345Z-K7QF`. Lesbar, nach Zeit sortierbar, und
 * mit vier Zeichen Zufall, damit zwei Fassungen in derselben Millisekunde (zwei Geräte) nicht
 * denselben Namen bekommen – „nur anhängen" verbietet Überschreiben.
 */
export function zeitstempel(jetzt: Date = new Date()): string {
  const iso = jetzt.toISOString() // 2026-10-20T10:36:12.345Z
  const kompakt = iso.replace(/[-:]/g, '').replace('.', '')
  return `${kompakt}-${zufall(4)}`
}

/** `20261020T103612345Z-K7QF` → Date. Für Fassungslisten, ohne die Datei zu öffnen. */
export function zeitAusStempel(stempel: string): Date | null {
  const m = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(\d{3})Z/.exec(stempel)
  if (!m) return null
  const [, j, mo, t, h, mi, s, ms] = m
  return new Date(`${j}-${mo}-${t}T${h}:${mi}:${s}.${ms}Z`)
}
